import { Link } from 'react-router-dom';
import { categoryList } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section className="py-16 md:py-20 bg-background-50" aria-labelledby="category-heading">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <p className="text-xs font-label tracking-[0.15em] uppercase text-foreground-500 mb-3">产品分类</p>
          <h2 id="category-heading" className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            五大品质品类，全方位守护生活
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categoryList.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300/60 transition-all duration-300 cursor-pointer flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-background-100 group-hover:bg-primary-100/80 transition-colors duration-300 mb-4">
                <i className={`${cat.icon} text-2xl text-foreground-700 group-hover:text-primary-500 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}